import { twMerge } from 'tailwind-merge'
import { Plus } from 'lucide-react'

import { formatTimestamp } from '@helpers/format'
import Image from '@components/Image'
import { Button } from '@components/ui/button'

const ChatList = ({ pages, selectedChatId, setSelectedChatId, createChat, isCreating, hasNextPage, fetchNextPage, isFetching, imageUrl, className }) => {
  return (
    <div className={twMerge('flex flex-col w-full h-full overflow-y-auto px-5 pt-3 shrink-0 sm:border-r', className)}>
      <If condition={imageUrl}>
        <Image
          className='object-cover w-full h-[200px] rounded-lg mb-3'
          src={imageUrl}
          placeholder={<div className='rounded-lg h-[200px] w-full bg-muted animate-pulse border shadow-sm mb-3' />}
        />
      </If>

      <Button
        onClick={() => createChat()}
        variant='ghost'
        className='mb-3 w-fit'
        loading={isCreating}
      >
        New Chat
        <Plus className='size-5' />
      </Button>

      <For each='page' of={pages}>
        <For each='chat' of={page.node.currentUserChats.nodes}>
          <div key={chat.id} className={twMerge('flex items-center justify-between bg-background rounded-lg w-full mb-3 border-1', chat.id === selectedChatId ? 'border-primary' : 'border-border')}>
            <button className='p-3 h-full' onClick={() => setSelectedChatId(chat.id)}>
              {formatTimestamp(chat.createdAt)}
            </button>
          </div>
        </For>
      </For>

      <If condition={hasNextPage}>
        <Button
          onClick={fetchNextPage}
          variant='outline'
          className='w-full mb-3 bg-muted hover:bg-muted/80'
          loading={isFetching}
        >
          {isFetching ? 'Loading...' : 'Load more'}
        </Button>
      </If>
    </div>
  )
}

export default ChatList;
